import { createBrowserRouter } from "react-router-dom";

export const router = createBrowserRouter([
  // Auth routes (no sidebar)
  {
    lazy: () => import("./_layouts/auth-layout"),
    children: [
      { path: "/login", lazy: () => import("./auth/login") },
      { path: "/register", lazy: () => import("./auth/register") },
      {
        path: "/forgot-password",
        lazy: () => import("./auth/forgot-password"),
      },
      {
        path: "/reset-password",
        lazy: () => import("./auth/reset-password"),
      },
    ],
  },
  // Dashboard routes (sidebar + topbar)
  {
    lazy: () => import("./_layouts/dashboard-layout"),
    children: [
      { path: "/", lazy: () => import("./overview") },
      { path: "/properties", lazy: () => import("./properties") },
      { path: "/properties/:id", lazy: () => import("./properties/[id]") },
      { path: "/financial", lazy: () => import("./financial") },
      {
        path: "/financial/income",
        lazy: () => import("./financial/income"),
      },
      {
        path: "/financial/expenses",
        lazy: () => import("./financial/expenses"),
      },
      {
        path: "/financial/mortgages",
        lazy: () => import("./financial/mortgages"),
      },
      {
        path: "/financial/yields",
        lazy: () => import("./financial/yields"),
      },
      { path: "/tenancies", lazy: () => import("./tenancies") },
      {
        path: "/tenancies/tenants",
        lazy: () => import("./tenancies/tenants"),
      },
      {
        path: "/tenancies/expiring",
        lazy: () => import("./tenancies/expiring"),
      },
      {
        path: "/tenancies/voids",
        lazy: () => import("./tenancies/voids"),
      },
      { path: "/maintenance", lazy: () => import("./maintenance") },
      {
        path: "/maintenance/contractors",
        lazy: () => import("./maintenance/contractors"),
      },
      {
        path: "/maintenance/activity",
        lazy: () => import("./maintenance/activity"),
      },
      {
        path: "/maintenance/:id",
        lazy: () => import("./maintenance/[id]"),
      },
      { path: "/compliance", lazy: () => import("./compliance") },
      {
        path: "/compliance/certificates",
        lazy: () => import("./compliance/certificates"),
      },
      {
        path: "/compliance/expiring",
        lazy: () => import("./compliance/expiring"),
      },
      {
        path: "/compliance/expired",
        lazy: () => import("./compliance/expired"),
      },
      {
        path: "/compliance/non-compliant",
        lazy: () => import("./compliance/non-compliant"),
      },
      {
        path: "/compliance/alerts",
        lazy: () => import("./compliance/alerts"),
      },
      { path: "/benchmarks", lazy: () => import("./benchmarks") },
      {
        path: "/benchmarks/compare",
        lazy: () => import("./benchmarks/compare"),
      },
      {
        path: "/benchmarks/market",
        lazy: () => import("./benchmarks/market"),
      },
      {
        path: "/benchmarks/scenarios",
        lazy: () => import("./benchmarks/scenarios"),
      },
      { path: "/intelligence", lazy: () => import("./intelligence") },
      { path: "/connections", lazy: () => import("./connections") },
      {
        path: "/connections/upload",
        lazy: () => import("./connections/upload"),
      },
      {
        path: "/connections/:id",
        lazy: () => import("./connections/[id]"),
      },
      { path: "/subscription", lazy: () => import("./subscription") },
      {
        path: "/subscription/success",
        lazy: () => import("./subscription/success"),
      },
      { path: "/notifications", lazy: () => import("./notifications") },
      {
        path: "/notifications/preferences",
        lazy: () => import("./notifications/preferences"),
      },
      { path: "/settings", lazy: () => import("./settings") },
    ],
  },
  // Onboarding (standalone — no sidebar/topbar)
  {
    lazy: () => import("./_layouts/onboarding-layout"),
    children: [
      { path: "/onboarding", lazy: () => import("./onboarding") },
    ],
  },
  // Catch-all 404
  { path: "*", lazy: () => import("./not-found") },
]);
